import { render, staticRenderFns } from "./expandableTotal.vue?vue&type=template&id=98ab63f8&"
import script from "./expandableTotal.vue?vue&type=script&lang=ts&"
export * from "./expandableTotal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports